import { render, staticRenderFns } from "./hrd-program-detail.vue?vue&type=template&id=df6d4888&scoped=true"
import script from "./hrd-program-detail.vue?vue&type=script&lang=js"
export * from "./hrd-program-detail.vue?vue&type=script&lang=js"
import style0 from "./hrd-program-detail.vue?vue&type=style&index=0&id=df6d4888&prod&scoped=true&lang=css"
import style1 from "./hrd-program-detail.vue?vue&type=style&index=1&id=df6d4888&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6d4888",
  null
  
)

export default component.exports